import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigationLocation } from "../../context/navigationContext.jsx"; // Assuming you have this context

const LinkWithCallback = ({ to, onClick, children,className }) => {
    // const { setNextLocation } = useNavigationLocation; // Get the function to store the next location
    const { setNextLocation } = useNavigationLocation(); // ✅ correctly call the hook

  const handleClick = (event) => {
    // Store the next location in the context before navigating
    // event.preventDefault(); // Prevent default link behavior
    // event.stopPropagation(); // Stop the event from bubbling up

    setNextLocation(to); // Store the target URL in the context

    // Call the custom function passed as onClick (if any)
    if (onClick) {
      onClick(event,to);
    }
  };

  return (
    <Link 
      to={to} 
      onClick={handleClick}
      className={className} 
      >
      {children}
    </Link>
  );
};

export default LinkWithCallback;
